import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import Video from '@src/components/video';
import { getBackgroundMusic } from '@src/components/audio';
import { observable } from 'mobx';
import { useEffect } from 'react';
import AntdMessage from '@src/components/antd/message';
import BaseStore from '@src/utils/store/base-store';
class RoleSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;

  @observable isActive = false;

  // 角色轮播图
  roleSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: false,
      spaceBetween: 0,
      autoplay: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      simulateTouch: false
    }
  });

  // 角色信息列表
  @observable
  roleMsgList = [
    {
      id: 'anka',
      name: '安卡',
      cvAudio: 'https://static-www.cbjq.com/20260121/Voice/MP3_ankaxiya_Voice.mp3',
      rolePv: '',
      gif: require('./images/anka/role_smoll.gif'),
      expandVideo: 'https://static-www.cbjq.com/20260121/video/ankaxiya_new.mp4',
      roleImg: require('./images/anka/role.png'),
      arms: require('./images/anka/rolearms.png'),
      label: require('./images/anka/rolelabel.png'),
      line: require('./images/anka/roletext.png'),
      icon: require('./images/anka/icon.png'),
      iconAct: require('./images/anka/icon-act.png')
    },
    {
      id: 'molian',
      name: '茉莉安',
      cvAudio: 'https://static-www.cbjq.com/20260121/Voice/MP3_molian_Voice_.mp3',
      rolePv: '',
      gif: require('./images/molian/role_smoll.gif'),
      expandVideo: 'https://static-www.cbjq.com/20260121/video/molian_new.mp4',
      roleImg: require('./images/molian/role.png'),
      arms: require('./images/molian/rolearms.png'),
      label: require('./images/molian/rolelabel.png'),
      line: require('./images/molian/roletext.png'),
      icon: require('./images/molian/icon.png'),
      iconAct: require('./images/molian/icon-act.png')
    }
  ];

  // 当前的角色cv音频
  @observable currentCvAudio;

  // 当前角色背景音乐是否播放
  @observable roleBgmAudioState;

  // 视频播放状态
  @observable videoPlayState;

  // 播放角色PV前的背景音乐状态（用于关闭后决定是否恢复）
  @observable bgmWasPlayingBeforePv = false;

  // 播放角色语音前的背景音乐状态（用于语音结束后决定是否恢复）
  @observable bgmWasPlayingBeforeAudio = false;

  changeRole(index) {
    // 切换角色时关闭当前播放的角色语音
    if (this.roleBgmAudioState && this.bgmAudio) {
      this.bgmAudio.stop();
      this.roleBgmAudioState = false;
      // 如果语音播放前BGM在播放，则恢复BGM
      if (this.mainStore && this.mainStore.bgm && this.bgmWasPlayingBeforeAudio) {
        this.mainStore.bgm.handleChange(true);
      }
      this.bgmWasPlayingBeforeAudio = false;
    }

    this.roleSwiper.onChange(index);
  }

  /**
   * 点击播放角色音频
   * @param roleId
   */
  onClickPlayRoleAudio = cvAudio => {
    // 记录当前BGM状态并在需要时关闭
    if (this.mainStore && this.mainStore.bgm) {
      this.bgmWasPlayingBeforeAudio = !!this.mainStore.bgm.isPlaying;
      if (this.bgmWasPlayingBeforeAudio) {
        this.mainStore.bgm.handleChange(false);
      }
    }

    if (!!this.roleBgmAudioState) {
      return false;
    }
    this.currentCvAudio = cvAudio;
    this.bgmAudio.audio.src = this.currentCvAudio;
    this.bgmAudio && this.bgmAudio.play();
    this.roleBgmAudioState = true;
  };

  /**
   * 点击展开视频
   * @param expandLink
   */
  pnClickPlayRoleVideo = roleVideo => {
    if (!roleVideo) {
      AntdMessage.info('敬请期待');
      return false;
    }

    // 记录当前BGM状态并在需要时关闭
    if (this.mainStore && this.mainStore.bgm) {
      this.bgmWasPlayingBeforePv = !!this.mainStore.bgm.isPlaying;
      if (this.bgmWasPlayingBeforePv) {
        this.mainStore.bgm.handleChange(false);
      }
    }

    // 如果角色语音正在播放，停止播放
    if (this.roleBgmAudioState && this.bgmAudio) {
      this.bgmAudio.stop();
      this.roleBgmAudioState = false;
    }

    this.videoPlayState = true;
    Video.append({
      src: roleVideo,
      onCloseCallback: () => {
        this.videoPlayState = false;
        // 仅当进入前BGM在播放时，才恢复播放
        if (this.mainStore && this.mainStore.bgm && this.bgmWasPlayingBeforePv) {
          this.mainStore.bgm.handleChange(true);
        }
        this.bgmWasPlayingBeforePv = false;
      }
    });
  };

  onResetAudioState = () => {
    this.roleBgmAudioState = false;
    // 仅当播放语音前BGM在播放时，才恢复播放
    if (this.mainStore && this.mainStore.bgm && this.bgmWasPlayingBeforeAudio) {
      this.mainStore.bgm.handleChange(true);
    }
    this.bgmWasPlayingBeforeAudio = false;
  };

  use() {
    super.use();
    useMount(() => {
      if (!this.bgmAudio) {
        this.bgmAudio = getBackgroundMusic({
          src: this.currentCvAudio,
          loop: false,
          endedCb: this.onResetAudioState
        });
      }
    });
    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 4;
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default RoleSectionStore;
